import { Button, Modal, Table } from 'antd';
import ConfigProviderCustomize from 'components/ConfigProviderCustomize';
import { useToast } from 'components/Toast';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { onHeaderCell } from 'utils/tableUtils';
import { ColumnsType } from 'antd/lib/table';
import { useDispatch, useSelector } from 'react-redux';
import { selectListReviewPgd } from 'store/initiativeAchievement/shared/selectors';
import * as FromCreateInitiativeSlice from 'store/initiativeAchievement/shared/slice';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { CreateInitiativeSaga } from 'store/initiativeAchievement/shared/saga';
import _ from 'lodash';
import ModalNoti from 'components/Modal/ModalNoti';
import Pagination from 'components/Pagination';

const ContainerTable = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
`;

enum INITIATIVE_STATUS_PERMISSION {
  'trường đã phân quyền' = 1,
  'trường chưa phân quyền' = 2,
  'sở đã phân quyền cv' = 3,
  'sở chưa phân quyền cv' = 4
}

interface DataType {
  id?: any;
  teacher_fullname: string;
  id_num: string;
  birthday: Date;
  phone_number: string;
  position_title: string;
  ma_cong_chuc: string;
  subject_name: string;
  action: string;
}

interface ModalSelectInitiativesProps {
  open: boolean;
  listItemsChoose: any[];
  listTeacherChoose: any[];
  gradeId: number;
  courseId: number;
  schoolId: any;
  handleCancel: () => void;
  handleRefresh: () => void;
  handleSuccess: (teacher: any[]) => void;
}

function ModalSelectInitiatives({
  open,
  listItemsChoose,
  listTeacherChoose,
  gradeId,
  courseId,
  schoolId,
  handleCancel,
  handleSuccess
}: ModalSelectInitiativesProps) {
  useInjectReducer({
    key: FromCreateInitiativeSlice.sliceKey,
    reducer: FromCreateInitiativeSlice.reducer
  });
  useInjectSaga({ key: FromCreateInitiativeSlice.sliceKey, saga: CreateInitiativeSaga });
  const toast = useToast();
  const dispatch = useDispatch();
  const listReview: any = useSelector(selectListReviewPgd);

  const [filterData, setFilterData] = useState({
    keyword: '',
    courseId: courseId,
    perPage: 10,
    pageId: 1,
    statusPermission: INITIATIVE_STATUS_PERMISSION['sở chưa phân quyền cv'],
    // gradeId: gradeId,
    schoolId: schoolId
  });

  const [valueSelect, setValueSelect] = useState<any[]>([]);
  const [valueSelectId, setValueSelectId] = useState<any[]>([]);
  const [teacher, setTeacher] = useState<any[]>([]);
  const [isOpenNoti, setIsOpenNoti] = useState<boolean>(false);

  const useEffectOnMount = (effect: React.EffectCallback) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [filterData]);
  };

  useEffectOnMount(() => {
    dispatch(FromCreateInitiativeSlice.actions.getEvaluationInitiativesPgds({ data: filterData }));
  });

  useEffect(() => {
    if (listItemsChoose) {
      setValueSelectId(listItemsChoose.map((item) => item.id));
    }
  }, [listItemsChoose]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      console.log(selectedRows);
      if (!isEmpty(selectedRows)) {
        selectedRows.forEach((item: any) => {
          isValueItem(item);
        });
      }
      console.log(isEmptyUser(selectedRows));
      if (isEmptyUser(selectedRows).length > 0) {
        setIsOpenNoti(true);
        return;
      }
      const dataSelected = selectedRows.filter(
        (item: any) =>
          item.description !== '' &&
          item.effective !== '' &&
          !isEmpty(item.files) &&
          !isEmpty(item.files_description)
      );
      setValueSelect(dataSelected);
      setValueSelectId(dataSelected.map((item) => item.id));
    }
  };

  const isValueItem = (data: {
    description: string;
    effective: string;
    files: any;
    files_description: any;
  }) => {
    if (data.description === '') {
      toast?.pushWarning('Sáng kiến chưa cập nhật mô tả!');
      return true;
    }
    if (data.effective === '') {
      toast?.pushWarning('Sáng kiến chưa cập nhật hiệu quả!');
      return true;
    }
    if (isEmpty(data.files)) {
      toast?.pushWarning('Sáng kiến chưa cập nhật File sáng kiến!');
      return true;
    }
    if (isEmpty(data.files_description)) {
      toast?.pushWarning('Sáng kiến chưa cập nhật File mô tả sáng kiến!');
      return true;
    }
    return false;
  };

  const isEmptyUser = (data: any[]) => {
    const user = listTeacherChoose.filter((item) =>
      data.some((itm: any) => itm?.user_id === item?.user_id)
    );
    if (user.length > 0) {
      setTeacher(user);
      return user;
    }
    return [];
  };

  const handleNext = () => {
    setFilterData((prev: any) => ({ ...prev, pageId: filterData.pageId + 1 }));
  };

  const handleRev = () => {
    if (filterData.pageId === 1) return;
    setFilterData((prev: any) => ({ ...prev, pageId: filterData.pageId - 1 }));
  };

  const selectPerpage = (e: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      pageId: 1,
      perPage: Number(e.key)
    }));
  };

  const isCheckDisable = useCallback((): boolean | undefined => {
    if (selectListReviewPgd.length < filterData.perPage) return true;
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData.perPage, selectListReviewPgd]);

  const handleSubmit = () => {
    if (valueSelect.length > 0) {
      handleSuccess(valueSelect);
      handleCancel();
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'STT',
      width: 100,
      align: 'center',
      onHeaderCell,
      render: (text, record, index) => {
        return <span>{(filterData.pageId - 1) * filterData.perPage + index + 1}</span>;
      }
    },
    {
      title: 'Mã công chức',
      dataIndex: 'ma_cong_chuc',
      key: 'ma_cong_chuc',
      width: 100,
      align: 'center',
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff' }}>{text}</span>;
      }
    },
    {
      title: 'Họ và tên',
      dataIndex: 'user_fullname',
      key: 'user_fullname',
      width: 300,
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff' }}>{text}</span>;
      }
    },
    {
      title: 'Tên sáng kiến',
      dataIndex: 'name',
      key: 'name',
      width: 300,
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff', cursor: 'pointer' }}>{text}</span>;
      }
    }
  ];

  return (
    <Modal
      title={'Danh sách sáng kiến'}
      centered
      visible={open}
      onCancel={() => handleCancel()}
      width={700}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Cập nhật
        </Button>
      ]}>
      <ContainerTable>
        <ConfigProviderCustomize>
          <Table
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: valueSelectId,
              ...rowSelection
            }}
            showHeader
            columns={columns}
            dataSource={!_.isEmpty(listReview) && listReview}
            size="middle"
            bordered
            pagination={false}
            // loading={loading}
            rowKey={(record: any) => record.id}
          />
        </ConfigProviderCustomize>
      </ContainerTable>
      <div className="mt-30">
        <Pagination
          current={filterData.pageId}
          onClickNext={() => handleNext()}
          onClickRev={() => handleRev()}
          rowsPerPage={filterData.perPage}
          onClickPerpage={selectPerpage}
          isDisableNext={isCheckDisable()}
        />
      </div>
      {isOpenNoti && (
        <ModalNoti
          isOpen
          titleName={`Vui lòng không phân quyền cho giáo viên <strong>${teacher[0].name}</strong> tự chấm sáng kiến của mình`}
          handleCancel={() => setIsOpenNoti(!isOpenNoti)}
        />
      )}
    </Modal>
  );
}

export default ModalSelectInitiatives;
